import React from 'react';
import logisticsImg from 'src/images/logistics.svg';
// import sanFranImg from 'src/images/san-francisco.svg';
import moneyTransferImg from 'src/images/money-transfer.svg';
import newYorkImg from 'src/images/new-york.svg';
import userGroupImg from 'src/images/user-group.svg';
import {
  Button,
  Col,
  Container,
  Icon,
  Row,
  TabContent,
  TabPane,
  useScreenSize
} from 'straightline-ui';

const Image = ({ src, alt }) => {
  const { isXs, isSm } = useScreenSize();
  const maxHeight = isXs || isSm ? 225 : 375;
  return (
    <div className="d-flex justify-content-center">
      <img
        src={src}
        alt={alt || 'Onboarding'}
        style={{ maxHeight }}
        className="mb-4 mb-md-5 animated fadeIn img-fluid"
      />
    </div>
  );
};

const Header = ({ children }) => {
  return <h1 className="text-md-center">{children}</h1>;
};

const Lead = ({ children }) => {
  return (
    <p className="mb-4 mb-md-5 text-md-center text-muted lead">{children}</p>
  );
};

const Tab = ({ children, ...rest }) => {
  const { isLg, isXl } = useScreenSize();
  const hasNavBar = !isLg && !isXl;
  return (
    <TabPane {...rest} mountOnEnter={false}>
      <div
        style={{
          height: hasNavBar ? 'calc(100vh - 61px)' : '100vh'
        }}
      >
        <div
          className="h-100 d-flex flex-column justify-content-between pt-5 pb-3 py-md-6"
          style={{
            maxHeight: 800
          }}
        >
          {children}
        </div>
      </div>
    </TabPane>
  );
};

const Buttons = (props) => {
  return <div className="mt-auto d-flex justify-content-between" {...props} />;
};

export default function Guide({ location }) {
  const { isXs, isSm } = useScreenSize();
  const isSmall = isXs || isSm;
  const step = location.query.step || '1';
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xl="8">
          <TabContent activeTab={step}>
            <Tab tabId="1">
              {/* <Image src={sanFranImg} alt="San Fransisco" /> */}
              <Image src={newYorkImg} alt="New York" />
              <Header>Let's get rolling!</Header>
              <Lead>
                You're just a few easy steps away from booking shipments with
                instant pricing and real-time updates. Follow the guide to get
                setup. You can always get back to this page by using the "Guide"
                link in the menu.
              </Lead>
              <Buttons>
                <div>{/*justify-content-between-spacer*/}</div>
                <Button to="/guide" query={{ step: 2 }} color="primary">
                  Next
                  <Icon type="arrow-right" className="ml-2" />
                </Button>
              </Buttons>
            </Tab>

            <Tab tabId="2">
              <Image src={moneyTransferImg} alt="Setup Payments" />
              <Header>Setup Payments</Header>
              <Lead>
                Straightline uses <a href="https://www.stripe.com">Stripe</a> to
                keep your personal bank and details secure. Add a payment method
                to pay invoices instantly. Contact us at{' '}
                <a href={`tel:${process.env.REACT_APP_SUPPORT_PHONE}`}>
                  {process.env.REACT_APP_SUPPORT_PHONE}
                </a>{' '}
                to request credit terms.
              </Lead>

              <Buttons>
                <div>
                  <Button to="/guide" query={{ step: 1 }} color="white">
                    <Icon type="arrow-left" className="mr-2" />
                    Back
                  </Button>
                </div>
                <div>
                  <Button
                    to="/settings/billing"
                    color="primary"
                    className="mr-3"
                  >
                    <Icon type="dollar-sign" className="mr-2" />
                    {!isSmall && 'Setup '}Payments
                  </Button>
                  <Button to="/guide" query={{ step: 3 }} color="primary">
                    Skip
                    <Icon type="arrow-right" className="ml-2" />
                  </Button>
                </div>
              </Buttons>
            </Tab>

            <Tab tabId="3">
              <Image src={userGroupImg} alt="Invite Users" />
              <Header>Invite Team</Header>
              <Lead>
                Invite team members to help manage your business. Users can
                receive notifications, view documents, update shipments, and get
                new quotes.
              </Lead>

              <Buttons>
                <div>
                  <Button to="/guide" query={{ step: 2 }} color="white">
                    <Icon type="arrow-left" className="mr-2" />
                    Back
                  </Button>
                </div>
                <div>
                  <Button to="/settings/users" className="mr-3" color="primary">
                    <Icon type="users" className="mr-2" />
                    {!isSmall && 'Invite '}Team
                  </Button>
                  <Button to="/guide" query={{ step: 4 }} color="primary">
                    Skip
                    <Icon type="arrow-right" className="ml-2" />
                  </Button>
                </div>
              </Buttons>
            </Tab>

            <Tab tabId="4">
              <Image src={logisticsImg} alt="Request Load" />
              <Header>Request Quote</Header>
              <Lead>
                Get instant quotes from the Straighline pricing algorithm. After
                accepting a quote, your shipment will begin matching with
                carriers nationwide! You can get new quotes anytime by clicking
                "Request Quote" in the menu.
              </Lead>
              <Buttons>
                <div>
                  <Button to="/guide" query={{ step: 3 }} color="white">
                    <Icon type="arrow-left" className="mr-2" />
                    Back
                  </Button>
                </div>
                <div>
                  <Button to="/quote" color="primary">
                    <Icon type="clipboard" className="mr-2" />
                    Request Quote
                  </Button>
                </div>
              </Buttons>
            </Tab>
          </TabContent>
        </Col>
      </Row>
    </Container>
  );
}
